import Model from "./CategorySettingsModel";
import View from "./CategorySettingsView";
import PageController from "../../../PageController";

class Controller extends PageController {
  constructor(model, view) {
    super();
    this._model = model;
    this._view = view;

    this._model.on("gotCategories", (results) => {
      this._view.render(results);
    });

    this._model.on("setErrors", (errors) => {
      this._view.setErrors(errors);
    });

    this._model.on("categorySaved", (response) => {
      this._view.successSave();
    });

    this._model.on("categoryDeleted", (response) => {
      this._view.successDelete();
    });
  }
}

const CategorySettings = (function () {
  return {
    init: () => {
      const model = new Model();
      const view = new View(model);
      const controller = new Controller(model, view);
    },
  };
})();

export default CategorySettings;
